import type {Error} from 'src/openapi/admin/models/Error';

type GetErrorProps = {
    error?: Error,
    separator?: string,
    errorListOnly?: boolean,
};

export const getError = ({error, separator = ';', errorListOnly}: GetErrorProps): string => {
    if (!error) {
        return '';
    }

    if ('stack' in error && typeof error.stack === 'string' && error.stack) {
        return 'Connection lost.';
    }

    return [...errorListOnly ? [] : [error.message || ''], ...(error.elementErrorList || [])].join(separator);
};
